export const careersStyles = (assertBaseUrl) => ({
  hero: {
    backgroundImage: `url(${assertBaseUrl}/images/hero-background.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    '@media (min-width: 1378px)': {
      backgroundImage: `url(${assertBaseUrl}/images/hero-background.jpg)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top',
      backgroundSize: 'cover',
    },
    '@media (max-width: 768px)': {
      backgroundImage: `url(${assertBaseUrl}/images/hero-background-tablet.jpg)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top',
      backgroundSize: '768px',
      backgroundColor: '#fff',
    },
    '@media (max-width: 480px)': {
      backgroundImage: `url(${assertBaseUrl}/images/hero-background-mobile.jpg)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top',
      backgroundSize: 'contain',
      backgroundColor: '#fff',
    },
  },
  benefits: {
    backgroundImage: `url(${assertBaseUrl}/images/benefits-bg.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    '@media (max-width: 980px)': {
      background: 'none',
      height: 'unset',
    },
  },
  benefits__image: {
    '@media (max-width: 980px)': {
      backgroundImage: `url(${assertBaseUrl}/images/benefits-bg-mobile.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
    },
  },
  'mejs-overlay-button': {
    backgroundImage: `url(${assertBaseUrl}/images/btn-play.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
});
